import { render, staticRenderFns } from "./Riwayat.vue?vue&type=template&id=aa2ed5ec"
import script from "./Riwayat.vue?vue&type=script&lang=js"
export * from "./Riwayat.vue?vue&type=script&lang=js"
import style0 from "./Riwayat.vue?vue&type=style&index=0&id=aa2ed5ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports